export default "__VITE_ASSET__Uj03HrYG__"